import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 49,
	viewBox: "0 0 40 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_128912_41499)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2 31.7V42.5C2 44.9853 4.01472 47 6.5 47H33.5C35.9852 47 38 44.9853 38 42.5V31.7M2 31.7V6.5C2 4.01472 4.01472 2 6.5 2H33.5C35.9852 2 38 4.01472 38 6.5V31.7M2 31.7H10.1C10.885 35.6249 14.3311 38.45 18.3336 38.45H20.7663C24.7688 38.45 28.215 35.6249 29 31.7H38M8.75 20.9H30.35M8.75 12.8H30.35",
			stroke: "currentColor",
			strokeWidth: 3.28767,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_128912_41499",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 49,
			fill: "white"
		})
	}) })]
});
export default SvgEmenu;
